import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import { SOCIAL_REPORT_MONTH_PATTERN } from '@repo/shared/marketing';
import { AgencySocialResultsPage } from '@/features/agency';
import { formatDocumentTitle } from '@/lib/document-title';

interface AgencySocialResultsSearch {
  /** "YYYY-MM"; omitted = the last full month (the API's default), so the plain nav link stays clean. */
  month?: string;
}

const parseMonth = (raw: unknown): string | null =>
  typeof raw === 'string' && SOCIAL_REPORT_MONTH_PATTERN.test(raw) ? raw : null;

/** Every agency member may view it (the parent layout gates non-agency users; the API scopes salons). */
export const Route = createFileRoute('/_auth/agency/social-results')({
  // An unknown value leaves the key out; the raw URL value can still show through it, so the page re-parses on read.
  validateSearch: (search: Record<string, unknown>): AgencySocialResultsSearch => {
    const month = parseMonth(search.month);
    return month ? { month } : {};
  },
  component: AgencySocialResultsRoute,
});

function AgencySocialResultsRoute() {
  const month = Route.useSearch({ select: (search) => parseMonth(search.month) });
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Social results')}</title>
      </Helmet>
      <AgencySocialResultsPage
        month={month}
        // A month pick replaces the history entry, so Back leaves the page instead of stepping through picks.
        onMonthChange={(next) => void navigate({ search: { month: next }, replace: true })}
      />
    </>
  );
}
